import { ILocationSuggest, TBoundedBy, TSuggestLocationType } from '@cian/geosuggest-widget/es/types';

import { ISuggestItemDataClassSchema } from '../../repositories/geo-suggest/entities/entities/SuggestItemDataClassSchema';

export const mapCities = (cities: ISuggestItemDataClassSchema[]): ILocationSuggest[] => {
  return cities.map(city => ({
    regionId: city.regionId as number,
    fullName: city.fullName,
    id: city.id,
    matches: city.matches as TBoundedBy,
    name: city.name,
    type: city.type as unknown as TSuggestLocationType,
  }));
};
